/* eslint-disable @stencil-community/required-jsdoc */
import { isEmpty } from '@springbokagency/stencil-base';
import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'efb-img',
  styleUrl: 'img.scss',
  shadow: true,
})
export class EfbImg {
  /**
   * Props
   */

  @Prop() path: string;

  @Prop() pathWebp?: string;

  @Prop() path2x?: string;

  @Prop() pathWebp2x?: string;

  @Prop() alt?: string = '';

  @Prop() cover?: boolean = false;

  @Prop() width?: number;

  @Prop() height?: number;

  /**
   * Render
   */

  render() {
    return (
      <Host class={{ cover: this.cover }}>
        <picture>
          {this.pathWebp && (
            <source
              srcSet={`${this.pathWebp} ${
                !isEmpty(this.pathWebp2x) ? `, ${this.pathWebp2x} 2x` : ''
              }`}
              type="image/webp"
            />
          )}
          <img
            src={this.path}
            srcset={!isEmpty(this.path2x) ? `${this.path2x} 2x` : ''}
            alt={this.alt}
            width={this.width}
            height={this.height}
            loading="lazy"
          />
        </picture>
      </Host>
    );
  }
}
